import {handleResponse} from '../utils'

// todo 感觉乌龙了...这部分和requests重叠了
function request (config) {
  return window.axios(config).then(handleResponse())
}

export default request
